import { Subject } from 'rxjs';

const tooltipStack: string[] = [];
const tooltipTopStackElementChanged = new Subject<string>();

export const useNestedTooltipStack = () => {
  const pushToStack = (id: string) => {
    tooltipStack.push(id);
    tooltipTopStackElementChanged.next(id);
  };
  const popFromStack = () => {
    tooltipStack.pop();
    tooltipTopStackElementChanged.next(tooltipStack[tooltipStack.length - 1]);
  };

  return {
    tooltipTopStackElementChanged,
    pushToStack,
    popFromStack,
  };
};
